
import { Question } from '../types';

export const taj101SifatQuestions: Question[] = [
  {
    id: 'taj041',
    text: 'What does ṣifāt mean in Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'Characteristics of letters', isCorrect: true },
      { id: 'b', text: 'Places of articulation', isCorrect: false },
      { id: 'c', text: 'Methods of recitation', isCorrect: false },
      { id: 'd', text: 'Rules of stopping', isCorrect: false }
    ],
    explanation: 'Ṣifāt is the plural of ṣifah. Literally, it means qualities or characteristics. Technically, ṣifāt are those characteristics which are affixed to the pronunciation of a letter, whether intrinsic or circumstantial.',
    topic: 'taj101'
  },
  {
    id: 'taj042',
    text: 'What are the two main types of ṣifāt (characteristics) of letters?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Ṣifāt lāzimah (intrinsic/permanent)', isCorrect: true },
      { id: 'b', text: 'Ṣifāt ʿāriḍah (temporary/circumstantial)', isCorrect: true },
      { id: 'c', text: 'Ṣifāt makhrajiyyah (articulatory)', isCorrect: false },
      { id: 'd', text: 'Ṣifāt sawṭiyyah (acoustic)', isCorrect: false }
    ],
    explanation: 'The ṣifāt of letters are of two types: ṣifāt lāzimah (intrinsic or permanent characteristics) and ṣifāt ʿāriḍah (temporary or circumstantial characteristics).',
    topic: 'taj101'
  },
  {
    id: 'taj043',
    text: 'How are the ṣifāt lāzimah (permanent characteristics) further divided?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Mutaḍāddah (those with opposites)', isCorrect: true },
      { id: 'b', text: 'Ghayr mutaḍāddah (those without opposites)', isCorrect: true },
      { id: 'c', text: 'Mushaddadah (emphasized)', isCorrect: false },
      { id: 'd', text: 'Mukhaffafah (lightened)', isCorrect: false }
    ],
    explanation: 'The ṣifāt lāzimah are divided into two types: mutaḍāddah (those ṣifāt which have opposites) and ghayr mutaḍāddah (those ṣifāt which have no opposites).',
    topic: 'taj101'
  },
  {
    id: 'taj044',
    text: 'What is hams in Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'When the breath flows during pronunciation', isCorrect: true },
      { id: 'b', text: 'When the sound is loud and clear', isCorrect: false },
      { id: 'c', text: 'When the sound is trapped in the throat', isCorrect: false },
      { id: 'd', text: 'When the letter is pronounced with emphasis', isCorrect: false }
    ],
    explanation: 'Hams (هَمْس) literally means a whisper. In Tajweed, it occurs when the breath flows during the pronunciation of certain letters. It has 10 letters found in the combination: فَحَثَّهُ شَخْصٌ سَكَتْ',
    topic: 'taj101'
  },
  {
    id: 'taj045',
    text: 'Which letters have the characteristic of hams?',
    type: 'single',
    options: [
      { id: 'a', text: 'The 10 letters in فَحَثَّهُ شَخْصٌ سَكَتْ', isCorrect: true },
      { id: 'b', text: 'All letters except those in يَرْمَلُوْنَ', isCorrect: false },
      { id: 'c', text: 'The 5 letters in قطب جد', isCorrect: false },
      { id: 'd', text: 'The 7 letters in خُصَّ ضَغْطٍ قِظْ', isCorrect: false }
    ],
    explanation: 'The letters that have the characteristic of hams are the 10 letters found in the combination: فَحَثَّهُ شَخْصٌ سَكَتْ',
    topic: 'taj101'
  },
  {
    id: 'taj046',
    text: 'What is jahr in Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'When the breath is imprisoned during pronunciation', isCorrect: true },
      { id: 'b', text: 'When the breath flows during pronunciation', isCorrect: false },
      { id: 'c', text: 'When the sound is very soft', isCorrect: false },
      { id: 'd', text: 'When the letter is pronounced with a whistling sound', isCorrect: false }
    ],
    explanation: 'Jahr (جَهْر) literally means to announce something loudly or publicly. This is the opposite of hams. The breath is imprisoned when pronouncing these letters. The letters of jahr are all the remaining letters of the Arabic alphabet besides the letters of hams.',
    topic: 'taj101'
  },
  {
    id: 'taj047',
    text: 'What is shiddah in Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'When the sound is imprisoned when reading these letters', isCorrect: true },
      { id: 'b', text: 'When the sound flows freely', isCorrect: false },
      { id: 'c', text: 'When the tongue rises toward the palate', isCorrect: false },
      { id: 'd', text: 'When the letter is pronounced with a whistling sound', isCorrect: false }
    ],
    explanation: 'Shiddah (شِدَّة) literally means strength. In Tajweed, it occurs when the sound is imprisoned when reading these letters. Its letters are found in the combination أَجِدْ قَطٍ بَكَتْ',
    topic: 'taj101'
  },
  {
    id: 'taj048',
    text: 'What is istiʿlāʾ in Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'When the back part of the tongue rises', isCorrect: true },
      { id: 'b', text: 'When the sound is imprisoned', isCorrect: false },
      { id: 'c', text: 'When the breath flows freely', isCorrect: false },
      { id: 'd', text: 'When the lips form a circle', isCorrect: false }
    ],
    explanation: 'Istiʿlāʾ (اِسْتِعْلاء) literally means to elevate. In Tajweed, the back part of the tongue rises when pronouncing the letters which have this characteristic. It is found in the 7 letters of خُصَّ ضَغْطٍ قِظْ',
    topic: 'taj101'
  },
  {
    id: 'taj049',
    text: 'What effect does istiʿlāʾ have on the pronunciation of letters?',
    type: 'single',
    options: [
      { id: 'a', text: 'It causes these letters to be pronounced with tafkhīm (full mouth/thick sound)', isCorrect: true },
      { id: 'b', text: 'It causes these letters to be pronounced with tarqīq (empty mouth/thin sound)', isCorrect: false },
      { id: 'c', text: 'It causes these letters to be prolonged', isCorrect: false },
      { id: 'd', text: 'It causes these letters to have a whistling sound', isCorrect: false }
    ],
    explanation: 'Due to the back part of the tongue rising during istiʿlāʾ, it causes these letters to be pronounced with a full mouth/thick sound (tafkhīm).',
    topic: 'taj101'
  },
  {
    id: 'taj050',
    text: 'What is iṭbāq in Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'When the center part of the tongue embraces the palate', isCorrect: true },
      { id: 'b', text: 'When the sound flows freely', isCorrect: false },
      { id: 'c', text: 'When the breath is imprisoned', isCorrect: false },
      { id: 'd', text: 'When the lips come together', isCorrect: false }
    ],
    explanation: 'Iṭbāq (إِطْبَاق) literally means lid or cover. In Tajweed, it occurs when the center part of the tongue embraces or encompasses the palate. Its letters are ṣād, ḍād, ṭāʾ, and ṭḥāʾ (ص, ض, ط, and ظ).',
    topic: 'taj101'
  }
];
